"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _liquidjs = require("liquidjs");
var _default = exports["default"] = Object.assign({}, _liquidjs.defaultOptions.operators, {
  // liquidjs does not support && or || operators. For backwards
  // compatibility, convert to "and" and "or".
  '&&': _liquidjs.defaultOptions.operators.and,
  '||': _liquidjs.defaultOptions.operators.or,
  '&gt;': _liquidjs.defaultOptions.operators['>'],
  '&gte;': _liquidjs.defaultOptions.operators['>='],
  '&lt;': _liquidjs.defaultOptions.operators['<'],
  '&lte;': _liquidjs.defaultOptions.operators['<=']
});